module.exports = __webpack_public_path__ + "static/media/add.1cefe022.svg";